import React, { useCallback, useState } from 'react';
import { TrendingUp } from 'lucide-react';
import PeFactsAcademy from '../components/premium-tools/pe-facts/components/PeFactsAcademy';
import PeFactsGenerator from '../components/premium-tools/pe-facts/components/PeFactsGenerator';

/**
 * PEFacts als volle Premium-Seite (Menü neben PEPapers / PEScout).
 * Logik bleibt gekapselt unter premium-tools/pe-facts/.
 */
const PeFactsPage: React.FC = () => {
  const [toast, setToast] = useState<{ msg: string; type: 'success' | 'error' } | null>(null);

  const showNotification = useCallback((msg: string, type: 'success' | 'error' = 'success') => {
    setToast({ msg, type });
    window.setTimeout(() => setToast(null), 3200);
  }, []);

  return (
    <div className="min-h-screen bg-pe-bg dark:bg-[#030303] text-slate-100 pb-16">
      {toast && (
        <div
          className={`fixed top-20 left-1/2 -translate-x-1/2 z-[100] px-5 py-3 rounded-xl text-xs font-black uppercase tracking-widest shadow-2xl border ${
            toast.type === 'error'
              ? 'bg-red-600/95 border-red-400 text-white'
              : 'bg-emerald-600/95 border-emerald-400 text-white'
          }`}
        >
          {toast.msg}
        </div>
      )}

      <div className="max-w-7xl mx-auto px-3 sm:px-6 pt-6">
        <div className="bg-slate-900/95 rounded-[2rem] border border-slate-800 shadow-2xl overflow-hidden">
          <div className="bg-[#0a0f1c] border-b border-slate-800 p-6 md:p-8 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-80 h-80 bg-[#E6C299]/10 rounded-full blur-3xl pointer-events-none" />
            <div className="flex items-center gap-4 relative z-10">
              <div className="w-14 h-14 bg-[#E6C299]/10 rounded-2xl flex items-center justify-center border border-[#E6C299]/30 shadow-[0_0_20px_rgba(230,194,153,0.15)] shrink-0">
                <TrendingUp className="w-7 h-7 text-[#E6C299]" />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h1 className="text-2xl md:text-3xl font-black tracking-tight">
                    <span className="italic text-[#E6C299]">PE</span>
                    <span className="text-white">Facts</span>
                    <span className="text-slate-400 font-bold text-lg md:text-xl ml-2">
                      · Preisanpassungs-Texter
                    </span>
                  </h1>
                  <span className="px-2 py-0.5 bg-[#E6C299]/20 text-[#E6C299] text-[9px] font-bold uppercase tracking-widest border border-[#E6C299]/30 rounded">
                    Premium
                  </span>
                </div>
                <p className="text-xs md:text-sm text-slate-400 font-mono uppercase tracking-widest">
                  Die eiserne Preis-Strategie (No-Sorry)
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
            <div className="lg:col-span-6">
              <PeFactsAcademy />
            </div>
            <div className="lg:col-span-6">
              <PeFactsGenerator showNotification={showNotification} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeFactsPage;
